<template>
  <private-gym-page id="reserveringen-page" name="payment-single" :has_fab="false">

    <f7-block-title medium>
      Betalingen
    </f7-block-title>

    <f7-block-title>
      Producten
    </f7-block-title>
    <f7-list media-list class="list-strong list-outline list-dividers">
      <f7-list-item
          title="Drinken"
          after="€2,49"
          link="#"
          @click="createSinglePayment(1)"
      >
      </f7-list-item>
      <f7-list-item
          title="Energy bar"
          after="€2,49"
          link="#"
          @click="createSinglePayment(2)"
      >
      </f7-list-item>
      <f7-list-item
          title="Eiwit supplement shake"
          after="€29,95"
          link="#"
          @click="createSinglePayment(6)"
      >
      </f7-list-item>
      <f7-list-item
          title="Boek: De Beste Verliezer"
          :after="bookPrice"
          link="#"
          @click="createSinglePayment(7)"
      >
      </f7-list-item>
    </f7-list>

    <f7-block-title>
      Services
    </f7-block-title>
    <f7-list media-list class="list-strong list-outline list-dividers">
      <f7-list-item
          title="Personal training (één uur)"
          after="€63,-"
          link="#"
          @click="createSinglePayment(3)"
      >
      </f7-list-item>
      <f7-list-item
          title="Abonnement (één termijn)"
          after="Variabel"
          link="#"
          @click="createSinglePayment(4)"
      >
      </f7-list-item>
      <f7-list-item
          title="Aangepast"
          link="#"
          @click="handleConfirmPrice"
      >
      </f7-list-item>
    </f7-list>

  </private-gym-page>
</template>

<script>

import PrivateGymPage from "../../pages/_layouts/PrivateGymPage.vue";

import moment from 'moment/dist/moment';
import 'moment/dist/locale/nl';
moment.locale('nl');

import {f7} from "framework7-vue";
import { AppLauncher } from '@capacitor/app-launcher';

export default {
  components: {PrivateGymPage},

  props: {
    f7route: Object,
    f7router: Object,
  },

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    current_user() {
      return this.$store.state.current_user.data;
    },
    isBrowser() {
      return this.$store.getters['app/is_browser'];
    },
    //TODO: Make price static after 2025-04-01
    bookPrice() {
      const startDate = moment('2025-02-01');
      const endDate = moment('2025-04-01');
      const currentDate = moment();
      if (currentDate.isBetween(startDate, endDate, null, '[]')) {
        return '€14,98 (50% korting)';
      } else {
        return '€29,95';
      }
    }
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    createSinglePayment(type, price) {
      this.$store.commit('app/show_loader', {}, {root: true});

      this.$store.dispatch('api/postEndpoint', {
        endpoint: '/payment-single',
        data: {
          type: type,
          price: price
        },
      }).then(response => {
        const url = response.data.checkoutUrl;
        // works in browser and app
        AppLauncher.openUrl({
          url: url,
        });
      }).finally(() => {
        this.$store.commit('app/hide_loader', {}, {root: true});
      })
    },
    handleConfirmPrice() {
      const vm = this;
      f7.dialog.prompt('Bedrag', function (price) {
        if (price.includes(',')) {
          price = price.replace(',', '.');
        }
        vm.createSinglePayment(5, Number(price).toFixed(2));
      });
    }
  },

  watch: {
    //
  }
};
</script>
